import React, { Component } from 'react';
import { setlog } from '@modules/58m';
export default class NewerGuide extends Component {
  constructor(){
    super();
    this.stepNum =2;

    if(localStorage.getItem("zpchatbot-newguide")){
      this.state={
        show:false,
      }
    }else{
      setlog("mchatbot_yindao_show");
      localStorage.setItem("zpchatbot-newguide",1)
      this.state={
        show:true,
        step:1,
      }
    }
  }
  gonext = ()=>{
    this.setState({'step':this.state.step+1});
  }
  stop = ()=>{
    this.setState({'show':false});
  }
  gomanual=()=>{
    this.setState({'show':false});
    this.props.history.push('/mcommonchat/manual');
  } 
  render() {
    const {show,step} = this.state;
    if(!show || this.stepNum<step){
      return null;
    }
    return (
        <div className="module-newer-guide">
          <div className="guide-wrap">
            {step===1?
            <div className="guide-page1">
                <div className="btn-gonext" onClick={this.gonext}></div>
                <div className="btn-guide-manual" onClick={this.gomanual}></div>
            </div>:null
            }
            {step===2?
              <div className="guide-page-2">
                <div className="btn-gonext" onClick={this.gonext}></div>
            </div>:null
            }
          </div>
        </div>

    );
  }
}
